import React from "react";
import TicketIcon from "@components/Icons/TicketIcon/index.js";

const VoucherList = ({ vouchers = [], isCandyBar, displayWord = "voucher" }) => {
    const filtered = vouchers.filter((v) => {
        if (!v.voucher_code_url) return false;
        if (isCandyBar === undefined) return true;
        return isCandyBar ? v.is_candy_bar === 1 : v.is_candy_bar === 0;
    });

    if (!filtered.length) return null;

    return (
        <div className="confirmation__list">
            {filtered.map((voucher, index) => (
                <div className="confirmation__item" key={`${isCandyBar ? "candy" : "voucher"}-${index}`}>
                    <a
                        className="button button__primary"
                        href={voucher.voucher_code_url}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <TicketIcon className="button__icon" />
                        Download {displayWord} {index + 1}
                    </a>
                </div>
            ))}
        </div>
    );
};

export default VoucherList;
